import React from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
  Table,
} from 'reactstrap';
import Alert from '../Widgets/Alert';
import LoaderSpinner from '../Widgets/LoaderSpinner';

const CreateAUser = props => {
  const {
    success,
    successMessage,
    failure,
    errorMessage,
    onUserChange,
    user,
    isSubmitting,
    onCreateUser,
  } = props;
  return (
    <Col xs='12'>
      <Card>
        <CardHeader>Create User</CardHeader>
        <CardBody>
          {<Alert active={success} message={successMessage} />}
          {<Alert type='danger' active={failure} message={errorMessage} />}
          <FormGroup>
            <Label htmlFor='full name'>Full Name</Label>
            <Input
              type='text'
              name='fullName'
              id='full-name-input'
              placeholder='Enter Full Name'
              value={user.fullName}
              onChange={onUserChange}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='username'>Username</Label>
            <Input
              type='text'
              name='username'
              placeholder='Enter Username'
              value={user.username}
              onChange={onUserChange}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='email'>Email</Label>
            <Input
              type='email'
              name='email'
              placeholder='Enter Email'
              value={user.email}
              onChange={onUserChange}
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='password'>Default Password</Label>
            <Input
              type='text'
              name='password'
              value={user.password}
              disabled={true}
            />
          </FormGroup>
          <div className='form-actions'>
            <Button
              onClick={onCreateUser}
              type='submit'
              color='primary'
              disabled={isSubmitting}>
              Submit
            </Button>
          </div>
        </CardBody>
      </Card>
      {isSubmitting && <LoaderSpinner />}
    </Col>
  );
};

export default CreateAUser;



// WEBPACK FOOTER //
// ./src/views/Components/CreateAUser.js